// 不同项目 一些差异性功能的描述 用于区分配置
/**
 * 描述
 * @param {String} name 域名关键字
 * @param {Boolean} preload 是否需要开启预加载
 * @param {Array} preloadPort 需要预加载的子项目端口
 * @param {Boolean} watermark 是否开启水印
 * @param {object} businessHeader header部分的一些模块
    * header部分定义
    * Knowledge：平台知识库
    * Msg: 消息
    * Work: 上下班
    * TenantSwitch：切换租户
    * CallBox：外呼
  @param {Array}  外部项目 差异性接口 废弃 三期统一
  @param {Boolean} redirect 是否开启链接重定向跳转
  @param {String} defaultHomePage 登录后默认跳转的页面 路由
  @param {String} appId 系统对应的id
  @param {object} imagesObj 图片资源
  @param {Array} loginDefine 登录集合的定义
    * name tab名称
    * component 组件名称
    *   - UserNameLogin 账号登录
    *   - VerificationLogin 手机号登录
    *   - AccountLogin 域账号登录
 */
// eslint-disable-next-line no-unused-vars
const domainNamDsl = [
// 灵格低代码演示平台
  {
    name: 'lowcode',
    preload: true,
    preloadPort: ['5000', '3091', '3092'],
    watermark: false,
    businessHeader:
    {
      Msg: 'right',
      TenantSwitch: 'left',
    },
    redirect: false,
    defaultHomePage: '',
    appId: '90001',
    imagesObj: {
      home: require('@/assets/images/home-img.png'),
    },
    loginDefine: [
      {
        name: '手机号登录',
        component: 'VerificationLogin',
      },
    ],
    elements: [],
  },
  // 租户管理平台
  {
    name: 'console',
    preload: true,
    preloadPort: [],
    watermark: false,
    businessHeader:
    {
      TenantSwitch: 'left',
    },
    redirect: false,
    defaultHomePage: '',
    appId: '70001',
    imagesObj: {
      home: require('@/assets/images/tenant_console_home@1x.png'),
    },
    loginDefine: [
      {
        name: '手机号登录',
        component: 'VerificationLogin',
      },
    ],
    elements: [],
  },
  // 医装智能采集分析平台
  {
    name: 'equipment',
    preload: true,
    preloadPort: [],
    watermark: false,
    businessHeader:
      {
        TenantSwitch: 'left',
      },
    redirect: false,
    defaultHomePage: '',
    appId: '60001',
    imagesObj: {
      home: require('@/assets/images/equipment_home@1x.png'),
    },
    loginDefine: [
      {
        name: '手机号登录',
        component: 'VerificationLogin',
      },
    ],
    elements: [],
  },
  // 英比翼一体机平台
  {
    name: 'allinones',
    preload: true,
    preloadPort: ['5000', '3091', '3092'],
    watermark: false,
    businessHeader:
        {
          Msg: 'right',
          TenantSwitch: 'left',
        },
    redirect: false,
    defaultHomePage: '',
    appId: '50001',
    imagesObj: {
      home: require('@/assets/images/allinone_home@3x.png'),
    },
    loginDefine: [
      {
        name: '手机号登录',
        component: 'VerificationLogin',
      },
    ],
    elements: [],
  },
  {
    name: 'lingbolive',
    preload: true,
    preloadPort: ['5000', '3091', '3092', '3096'],
    watermark: false,
    businessHeader:
        {
          Msg: 'right',
          TenantSwitch: 'left',
        },
    redirect: false,
    defaultHomePage: '',
    appId: '100001',
    imagesObj: {
      home: require('@/assets/images/home-img.png'),
    },
    loginDefine: [
      {
        name: '手机号登录',
        component: 'VerificationLogin',
      },
    ],
    elements: [],
  },
  {
        name: 'web',
        preload: true,
        preloadPort: ['5000', '3091', '3092', '3096'],
        watermark: false,
        businessHeader:
                {
                  Msg: 'right',
                  TenantSwitch: 'left',
                },
        redirect: false,
        defaultHomePage: '',
        appId: '200001',
        imagesObj: {
          home: require('@/assets/images/dz-home.png'),
        },
        loginDefine: [
          {
            name: '手机号登录',
            component: 'VerificationLogin',
          },
        ],
        elements: [],
      },
  // 灵播Live
  {
    name: 'admin',
    preload: true,
    preloadPort: ['5000', '3091', '3092', '3096'],
    watermark: false,
    businessHeader:
            {
              Msg: 'right',
              TenantSwitch: 'left',
            },
    redirect: false,
    defaultHomePage: '',
    appId: '100001',
    imagesObj: {
      home: require('@/assets/images/home-img.png'),
    },
    loginDefine: [
      {
        name: '手机号登录',
        component: 'VerificationLogin',
      },
    ],
    elements: [],
  },
  {
    name: 'lingbomanager',
    preload: true,
    preloadPort: ['5000', '3091', '3092', '3096'],
    watermark: false,
    businessHeader:
            {
              Msg: 'right',
              TenantSwitch: 'left',
            },
    redirect: false,
    defaultHomePage: '',
    appId: '200001',
    imagesObj: {
      home: require('@/assets/images/dz-home.png'),
    },
    loginDefine: [
      {
        name: '手机号登录',
        component: 'VerificationLogin',
      },
    ],
    elements: [],
  },
  {
    name: 'cloud',
    preload: true,
    preloadPort: ['5000', '3091', '3092', '3096'],
    watermark: false,
    businessHeader: {
      Msg: 'right',
      TenantSwitch: 'left',
    },
    redirect: false,
    defaultHomePage: '',
    appId: '300001',
    imagesObj: {
      home: require('@/assets/images/dz-home.png'),
    },
    loginDefine: [
      {
        name: '手机号登录',
        component: 'VerificationLogin',
      },
    ],
    elements: [],
  },

  {
    name: 'workflow',
    preload: true,
    preloadPort: [],
    watermark: false,
    businessHeader:
            {
              Msg: 'right',
              TenantSwitch: 'left',
            },
    redirect: false,
    defaultHomePage: '',
    appId: '99999',
    imagesObj: {},
    loginDefine: [
      {
        name: '手机号登录',
        component: 'VerificationLogin',
      },
    ],
    elements: [],
  },
];

export {
  domainNamDsl,
};
